import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';

import './Icon.scss';

export default function Icon(props) {
  const { type, className, ...otherProps } = props;

  // if `type` contains `.` or `/` it's treated as a URL
  if (/[/.]/.test(type)) {
    return <img src={type} className={className} {...otherProps} />;
  }

  return <i className={classnames(type, className)} {...otherProps} />;
}

Icon.propTypes = {
  /**
   * type can either be an icon name, or a URL
   */
  type: PropTypes.string.isRequired,
  /**
   * html class to pass onto the element
   */
  className: PropTypes.string,
  /**
   * svg node to render as an icon
   */
  children: PropTypes.node,
};

Icon.defaultProps = {
  className: '',
  children: null,
};

Icon.displayName = 'Icon';
